import React from 'react';
import IconBase, { iconPropTypes } from '../IconBase';
import './loading.scss';

export default function LoadingIcon(props) {
	return (
		<IconBase type="loading" {...props}>
			<circle className="pos1" cx="3" cy="12" r="3" />
			<circle className="pos2" cx="12" cy="12" r="3" />
			<circle className="pos3" cx="21" cy="12" r="3" />
		</IconBase>
	);
}
LoadingIcon.propTypes = iconPropTypes;
